import React from 'react';
import PropTypes from 'prop-types';

import './SpecialServiceBanner.scss';
import { MenuIcon } from 'components/MegaMenu/subcomponents';
import IconSVG from 'components/IconSVG';
import { useIsMobile } from '../../../../../../hooks/useIsMobile';

const SpecialServiceBanner = ({ data }) => {
  if (!data || data.type !== 'SPECIAL_SERVICE') {
    return null;
  }

  const isMobile = useIsMobile(480);

  const { label, title, description, icon, url } = data;

  const getBannerLayout = () => {
    const desktopView = (
      <>
        <div className={'special_service__icon'}>
          <MenuIcon
            type={icon}
            showMobile={isMobile}
            alt={`${label} icon`}
          />
        </div>
        <div className={'special_service__text'}>
          {!isMobile && (<span className={'special_service_label'}>{label}</span>)}
          <h6 className={'special_service_title'}>{title}</h6>
          {description && (
            <span className={'special_service__description'}>
              {description}
            </span>
          )}
        </div>
        <div className={'special_service__arrow'}>
          <IconSVG name={'arrow-right'} color={'violet'} />
        </div></>
    )

    if (isMobile) {
      return (
        <div className={"special_service__mobile_layout"}>{desktopView}</div >
      )
    }

    return desktopView;
  }

  return (
    <a href={url} className={'special_service__banner'}>
      {isMobile && (<span className={'special_service_label'}>{label}</span>)}
      {getBannerLayout()}
    </a>
  );
};

SpecialServiceBanner.propTypes = {
  data: PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
};

SpecialServiceBanner.defaultProps = {
  data: {},
};

export default SpecialServiceBanner;
